import { LoadScript } from '@react-google-maps/api';
import { ReactNode, useState } from 'react';

// LoadScript only renders its children once the Maps script loads, and never
// if it fails, e.g. behind an ad blocker or during a Maps outage. This throws
// instead, so the app's error boundary logs it and offers a reload rather than
// leaving a blank page. When the boundary resets, this remounts and loads the
// script again.
const GoogleMapsScript = ({
  googleMapsApiKey,
  children,
}: {
  googleMapsApiKey: string;
  children: ReactNode;
}): JSX.Element => {
  const [failed, setFailed] = useState(false);
  if (failed) throw new Error('The Google Maps script failed to load');

  return (
    <LoadScript
      id="googleMap"
      googleMapsApiKey={googleMapsApiKey}
      // The library passes the script's error event, not an Error.
      onError={(): void => setFailed(true)}
      // Show nothing while the script loads, not the library's unstyled
      // "Loading..." text.
      loadingElement={<div />}
    >
      {children}
    </LoadScript>
  );
};

export default GoogleMapsScript;
